import {
  CREATE_SMP_LIST_SUCCESS,
  CREATE_SMP_LIST_ERROR,
  CREATE_SMP_LIST_LOADING,
  CLEAR_SMP_LIST,
} from "../../../constant/actionTypes";

const createSmpListReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_SMP_LIST_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case CREATE_SMP_LIST_SUCCESS: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CREATE_SMP_LIST_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    case CLEAR_SMP_LIST: {
      let obj = {
        loading: false,
        status: "",
      };
      return obj;
    }

    default:
      return state;
  }
};

export default createSmpListReducer;
